String.prototype.capitalize = function () {
    return this.replace(/\b\w/g, function (char) {
        return char.toUpperCase();
    });
}